import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUnleashClient } from 'utils/flags/unleashClient';

export const UnleashFeatureGuard = ({
  featureFlag,
  redirectPath = '/app',
  children,
}: {
  featureFlag: string[] | string;
  redirectPath?: string;
  children: React.ReactNode;
}) => {
  const unleashClient = getUnleashClient();
  const isFeatureEnabled = Array.isArray(featureFlag)
    ? featureFlag.some((flag) => unleashClient.isEnabled(flag))
    : unleashClient.isEnabled(featureFlag);

  return isFeatureEnabled ? (
    <>{children}</>
  ) : (
    <Navigate to={redirectPath} replace />
  );
};
